import { render, staticRenderFns } from "./recording.vue?vue&type=template&id=d7e8e664&scoped=true&"
import script from "./recording.vue?vue&type=script&lang=js&"
export * from "./recording.vue?vue&type=script&lang=js&"
import style0 from "./recording.vue?vue&type=style&index=0&id=d7e8e664&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e8e664",
  null
  
)

export default component.exports